import graphql__affbb065077cfeca88be from "./__generated__/ContributionsGridTiles_participativeModule.graphql.js";import { graphql } from "react-relay";

import useFilterableContributionsList from "./useFilterableContributionsList";
import { CONTRIBUTIONS_BATCH_SIZE } from "./ContributionsGrid";
import GridContribution from "./GridContribution";
import InfinitelyScrollableContainer from "../../Utils/InfinitelyScrollableContainer";
import { BoxSpinner } from "../../Utils/Spinner";

const ContributionsGridTiles = props => {
  const { contributions, isLoading, loadMore, isLoadingNext, emptyListMessage } =
    useFilterableContributionsList({
      contribuable: props.participativeModule,
      fragment: ContributionsGridTiles_participativeModule,
      contributionsBatchSize: CONTRIBUTIONS_BATCH_SIZE
    });

  return (
    <div className="contributions-list position-relative">
      <InfinitelyScrollableContainer
        className="contributions-grid row"
        onBottomReached={loadMore}
      >
        {contributions.map(contribution => (
          <GridContribution key={contribution.id} contribution={contribution} />
        ))}

        {/* Message displayed when there's no contribution, with a specific
            message, whether there is no contribution published, or if the
            filtered list has no results */}
        {emptyListMessage && (
          <div className="col-12 contribution-grid-tile">
            <div className="box padding-md">{emptyListMessage}</div>
          </div>
        )}

        {/* Overlay displayed on top of contributions while the contributions
            list is reloaded, after the filters are updated */}
        {isLoading && (
          <div className="col-12 contribution-grid-tile">
            <div className="container-overlay" />
          </div>
        )}

        {isLoadingNext && (
          <div className="col-12 contribution-grid-tile">
            <BoxSpinner />
          </div>
        )}
      </InfinitelyScrollableContainer>
    </div>
  );
};

export const ContributionsGridTiles_participativeModule = graphql__affbb065077cfeca88be;

export default ContributionsGridTiles;
